module.exports = __webpack_public_path__ + "static/media/gameOver.de7155b6.mp3";